import { useSuspenseQuery } from '@tanstack/react-query';
import { Outlet } from 'react-router-dom';

import { checkoutLayoutQueryOptions } from '@lib/query/options/layout';

/**
 * Checkout layout - minimal layout for checkout flow
 * Mirrors Next.js (checkout) route group layout
 *
 * Uses useSuspenseQuery to fetch layout data before rendering children.
 * This triggers the Suspense boundary in routes/index.tsx to show FullScreenLoader
 * until the layout endpoint responds.
 */
export default function CheckoutLayout() {
  // Fetch checkout layout data (customer info, auth state)
  // useSuspenseQuery guarantees data is available before children render,
  // so child pages can safely read layout cache without null guards.
  useSuspenseQuery(checkoutLayoutQueryOptions());

  return (
    <div className="small:min-h-screen relative w-full bg-white">
      <div className="relative" data-testid="checkout-container">
        <Outlet />
      </div>
    </div>
  );
}
